import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function AgentSetup() {

    return (
        <div>
            <DHeader>Setting up the Agent</DHeader>

            <DCode>
                {`agent = ReActAgent( name="BillingAgent", config = {
        "api_key_path":'../../.env',
        "reasoner":reasoner_llm, 
        "role":agent_role, 
        "instructions":agent_instructions, 
        "tools":{}
    })
        `}
            </DCode>


       
          
       
        </div>
    )
}